import React from 'react';

import classes from './Error.module.scss';

const NoPermissionPage = () => {
  return (
    <div className={classes.container}>
      <h4 className={classes.headerText}>
        You have no permissions to see this page
        <br />
        Please contact your administrator to learn more
      </h4>
    </div>
  );
};

export default NoPermissionPage;
